import List from 'src/storage/treatmentsList';

class TreatmentsTreatmentsModel extends List {
  id = 'TreatmentsModel';
  defaultState = () => ({
    current: 'recent',
    pageIndex: 0,
    openId: null,
    sortBy: {
      sortKey: 'date',
      desc: true
    }
  });
  refreshOnInit = true;
  refreshOnSubscribe = false;
  sortBy = null;
  apiConfig = {
    refresh: {
      url: 'treatment/refresh',
      validation: {
        partnerId: 'userId',
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    },
    list: {
      url: 'treatment/list',
      validation: {
        partnerId: 'userId',
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    },
    search: {
      url: 'treatment/search',
      validation: {
        partnerId: 'userId',
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    },
    patient_detail: {
      url: 'patient/detail',
      validation: {
        id: 'userId'
      },
      cancellable: true
    }
  };

  _events = {
    'foxsocket:message:treatment': 'onMessage',
    'foxsocket:message:treatment_update': 'onTreatmentUpdateWS',
    'foxsocket:message:treatment_remove': 'onTreatmentRemoveWS',
    treatment_remove: 'onTreatmentRemove',
    profile: 'handleChangeProfileAndSwitchAccount'
  };

  onTreatmentUpdateWS = ({ data }) => {
    let item = this.mapItem(data);
    this.updateItem(item, { listId: 'recent' });
    this.updateItem(item, { listId: 'search' });
  };

  onTreatmentRemoveWS = ({ data: id }) => {
    this.onTreatmentRemove(id);
  };

  onTreatmentRemove = (id) => {
    this.removeItem(id, { listId: 'recent' });
    this.removeItem(id, { listId: 'search' });
  };

  filterItem = (data) => {
    if (data.to !== this.userId && data.from !== this.userId) return false;
    return this.onFilterOtherItem(data);
  };

  listParams() {
    let req = {
      partnerId: 0,
      skip: this.state.pageIndex * this.listLimit,
      limit: this.listLimit,
      sortBy: this.state.sortBy
    };

    if (this.state.hospitalId) req.hospitalIds = [this.state.hospitalId];

    let query = this.listInput('search');
    if (query.length > 0) {
      req.query = query;
    }
    return req;
  }

  loadPatient = (id, cb) => {
    this.api('patient_detail', { id }, cb);
  };
}

const model = new TreatmentsTreatmentsModel();
export default model;
